export default __webpack_public_path__ + "static/media/Asset4.d4070014.svg";